import { AfterViewInit, Component, Input, NgZone, OnChanges, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import {
  CHART_COLORS,
  CHART_FONTS,
  CHART_STYLES,
} from 'src/app/domain/shared/component/pie-chart-simple/highcharts-common/highcharts-global-const';
import { HighchartsService } from 'src/app/domain/shared/component/pie-chart-simple/highcharts-common/highcharts.service';
import { BestWorstDealInput } from '../../../../pp/component/sub/pp-overview/service/BestWorstDealCalculation';

@Component({
  selector: 'app-best-deal-worst-deal-chart',
  templateUrl: './best-deal-worst-deal-chart.component.html',
  styleUrls: ['./best-deal-worst-deal-chart.component.scss'],
})
export class BestDealWorstDealChartComponent implements OnChanges, AfterViewInit {

  @Input() bestWorstDealInput: BestWorstDealInput;
  @Input() showEmptyState = false;

  options: any;

  constructor(private zone: NgZone) {}

  ngAfterViewInit(): void {
    this.renderChart();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.returnOptions();

    if (changes.bestWorstDealInput && this.options) {
      this.collectData();
      if (document.getElementById('bestDealWorstDealChart')) {
        this.renderChart();
      }
    }
  }

  returnOptions(): void {
    this.options = {
      chart: {
        zoomType: 'xy',
        reflow: true,
        zooming: {
          mouseWheel: false,
        },
      },
      title: {
        text: undefined,
      },
      xAxis: [{
        categories: [],
        type: 'category',
        labels: CHART_STYLES.xAxisLabelsStyle,
      }],
      yAxis: [{
        title: {
          text: '',
        },
        labels: {
          format: 'x{value:.2f}',
          style: {
            color: CHART_COLORS.black12,
            fontSize: CHART_FONTS.font4,
          },
        },
      }],
      exporting: CHART_STYLES.hiddenExportingButton,
      tooltip: CHART_STYLES.tooltipOneLineWithX,
      legend: {
        enabled: false,
      },
      plotOptions: {
        column: {
          width: 100,
          stacking: 'normal',
          dataLabels: CHART_STYLES.dataLabelsWithX,
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          type: 'column',
          color: CHART_COLORS.grey,
          data: [],
        },
      ],
      lang: CHART_STYLES.lang,
    };
  }

  collectData(): void {
    if (this.bestWorstDealInput.investmentTotalExcluding) {

      let investmentTotalIncluding = this.bestWorstDealInput.investmentTotalExcluding;
      let valueTotalIncluding = this.bestWorstDealInput.valueTotalExcluding;

      if (!this.bestWorstDealInput.bestTie) {
        investmentTotalIncluding += this.bestWorstDealInput.bestDeal.cost;
        valueTotalIncluding += this.bestWorstDealInput.bestDeal.fairValue;
      }
      if (!this.bestWorstDealInput.worstTie) {
        investmentTotalIncluding += this.bestWorstDealInput.worstDeal.cost;
        valueTotalIncluding += this.bestWorstDealInput.worstDeal.fairValue;
      }

      this.options.xAxis[0].categories.push('All deals');
      this.options.series[0].data.push(valueTotalIncluding / investmentTotalIncluding);

      if (!this.bestWorstDealInput.bestTie) {
        this.options.xAxis[0].categories.push('Excluding best\n deal');
        this.options.series[0].data.push((valueTotalIncluding - this.bestWorstDealInput.bestDeal.fairValue) /
          (investmentTotalIncluding - this.bestWorstDealInput.bestDeal.cost));
      }
      if (!this.bestWorstDealInput.worstTie) {
        this.options.xAxis[0].categories.push('Excluding worst\n deal');
        this.options.series[0].data.push((valueTotalIncluding - this.bestWorstDealInput.worstDeal.fairValue) /
          (investmentTotalIncluding - this.bestWorstDealInput.worstDeal.cost));
      }
      if (!this.bestWorstDealInput.bestTie && !this.bestWorstDealInput.worstTie) {
        this.options.xAxis[0].categories.push('Excluding best\n and worst deal');
        this.options.series[0].data.push(
          (valueTotalIncluding - this.bestWorstDealInput.worstDeal.fairValue - this.bestWorstDealInput.bestDeal.fairValue)
            / (investmentTotalIncluding - this.bestWorstDealInput.worstDeal.cost - this.bestWorstDealInput.bestDeal.cost),
        );
      }
      const maxValue = Math.max(...this.options.series[0].data);
      if (maxValue < 3) { // make custom tick positions only till moic < 3
        this.options.yAxis[0].tickPositions = HighchartsService.calculateTickPositions(maxValue);
      }
    }
  }

  renderChart(): void {
    this.zone.runOutsideAngular(() => {
      Highcharts.chart('bestDealWorstDealChart', this.options);
    });
  }
}

